import { ReactElement } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";
import { IContentAreaProps } from "../../../../../types";
import { IBilletTons } from "../types";
import { formatNumber } from "../../../../../system/utils";
import StyledTableRow from "../../../../../components/styledTableRow";
import TableContainer  from "../../../../../components/tableContainer";

interface IBilletTonsProps extends IContentAreaProps {
  columns: string[];
  data: IBilletTons[];
}


const BilletTonsTable = ({ data, columns, parentSize }: IBilletTonsProps): ReactElement => {
  const tableContent: any = [];
  const consolidateContent: any = { total: 0 };

  data.forEach(row => {
    let dayData = tableContent.find((x: any) => x.factoryDay === row.factoryDay);
    if (!dayData) {
      dayData = {
        day: row.day,
        factoryDay: row.factoryDay,
      };

      tableContent.push(dayData);
    }

    dayData[row.crewName] = row.total;

    if (!consolidateContent[row.crewName]) {
      consolidateContent[row.crewName] = row.total;
    } else {
      consolidateContent[row.crewName] += row.total;
    }

    consolidateContent.total += row.total;
  });

  return (
    <TableContainer style={{ height: parentSize.height - 70 }}>
      <Table stickyHeader={true} size={"small"}>
        <TableHead>
          <TableRow>
            <TableCell
              style={{ backgroundColor: "#b0bec5",  minWidth: 60 }}
              align="right">
              Day
            </TableCell>

            {columns.map((column) =>
              <TableCell
                style={{ backgroundColor: "#b0bec5",  minWidth: 60 }}
                key={`col-bt-${column}`}
                align="right">
                {column}
              </TableCell>
            )}

            <TableCell
              style={{ backgroundColor: "#b0bec5", minWidth: 60 }}
              align="right">
              Total
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {tableContent.map((row: any, index: number) => {
            let total = 0;

            return (
              <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`day-row-${index}`}>
                <TableCell align="right">
                  {row.day}
                </TableCell>

                {columns.map((column) => {

                  const crewData = row[column];

                  total += crewData ? crewData : 0;

                  return (
                    <TableCell key={`row-${column}-${index}`} align={"right"}>
                      {crewData && formatNumber(crewData, 1)}
                    </TableCell>
                  );
                })}

                <TableCell align="right">
                  {formatNumber(total, 1)}
                </TableCell>
              </StyledTableRow>
            );
          })
          }
          <TableRow>
            <TableCell
              style={{
                backgroundColor: "#b0bec5",
                fontWeight: "bold",
                width: 60
              }}
              align="right">
              Total
            </TableCell>

            {columns.map((column) =>
              <TableCell
                key={`row-consolidate-${column}`}
                style={{
                  backgroundColor: "#b0bec5",
                  fontWeight: "bold",
                  width: 60
                }}
                align="right">
                {formatNumber(consolidateContent[column], 1)}
              </TableCell>
            )
            }
            <TableCell
              style={{
                backgroundColor: "#b0bec5",
                fontWeight: "bold",
                width: 60
              }}
              align="right">
              {formatNumber(consolidateContent.total, 1)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BilletTonsTable;
